import { equals } from 'ramda';
import { memo } from 'react';

export interface SpotPriceLabelProps {
  spotPrice: number;
  unit: string;
  locale: string;
}

export function SpotPriceLabelMemo({ spotPrice, unit, locale }: Readonly<SpotPriceLabelProps>) {
  return (
    <>
      {`${spotPrice.toLocaleString(locale, {
        maximumFractionDigits: 1,
        useGrouping: false,
      })} ${unit}`}
    </>
  );
}

export const SpotPriceLabel = memo(SpotPriceLabelMemo, equals);
